<template>
  <v-container>
    <v-overlay :value="loading_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>


    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-container>

        <!--DATI GENERALI-->
        <v-card>

          <v-card-title fixed class="fixed teal lighten-1 white--text py-1 bold sticky-zero"
          >Dati Generali Pratica {{ form.cod.val }}
            <v-spacer/>
            <v-icon
                class="white--text"
            >mdi-briefcase-outline
            </v-icon
            >
          </v-card-title>
          <v-card-text class="pb-0">
            <v-row class="mt-3">
              <v-col class="px-0" cols="12" md="2">
                <v-text-field
                    label="Cod"
                    v-model="form.cod.val"
                    :rules="[rules.required, rules.max(255)]"
                    :disabled="editMode"
                    dense
                >
                </v-text-field>
              </v-col>
              <v-col class="px-0" cols="12" md="6">
                <v-text-field
                    dense
                    label="Nome Pratica"
                    v-model="form.nome.val"
                    :rules="[rules.max(255)]"
                >
                </v-text-field>
              </v-col>
              <v-col class="px-0" cols="12" md="2">
                <MjDateOrTimePicker
                    dense
                    label="Data Pratica"
                    v-model="form.data.val"
                    mode="date"
                    model_format="YYYY-MM-DD"
                    display_format="DD-MM-YYYY"
                >
                </MjDateOrTimePicker>
              </v-col>
              <v-col class="py-0" cols="12" md="2">
                <v-switch
                    label="Conclusa"
                    v-model="form.stato.val"
                    :true-value="1"
                    :false-value="0"
                    dense
                >
                </v-switch>
              </v-col>
            </v-row>
            <v-row>

              <v-col class="py-0" cols="12" md="3">
                <v-autocomplete
                    dense
                    label="Responsabile"
                    v-model="form.users_id.val"

                    :item-text="(item) => `${item.name} - ${item.email}`"
                    item-value="id"
                    :items="this.selects.users_id"
                    cache-items
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                    dense
                    label="Link video chat"
                    v-model="form.link_video_chat.val"
                    :rules="[rules.max(255)]"
                    append-outer-icon="mdi-chevron-right-circle-outline"
                    @click:append-outer="openLinkVideoChat"
                >
                </v-text-field>
              </v-col>
              <v-col class="py-0" cols="5">
                <v-textarea dense label="Nota" v-model="form.nota.val" rows="1">
                </v-textarea>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
        <!--SCADENZE-->
        <v-card class="mt-2 scroll-y" max-height="500">

          <v-card-title class="teal lighten-1 white--text py-1 sticky-zero">
            Scadenze
            <v-spacer/>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    x-small
                    color="red white--text"
                    class="ml-2 mb-1"
                    @click="syncGCal"
                >
                  <v-icon>mdi-calendar-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>Invia a G.Cal</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    x-small
                    color="green white--text"
                    class="ml-2 mb-1"
                    @click="concludiScadenze"
                >
                  <v-icon>mdi-check-all</v-icon>
                </v-btn>
              </template>
              <span>Segna come Conclusa</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    x-small
                    color="orange white--text"
                    class="ml-2 mb-1"
                    @click="removeScadenze"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Cancella Scadenza</span>
            </v-tooltip>
            <!--            <v-icon class="white&#45;&#45;text"-->
            <!--            >mdi-calendar-text-outline-->
            <!--            </v-icon-->
            <!--            >-->
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col>
                <v-autocomplete
                    class="ml-3 mr-3 mb-0 pb-0"
                    ref="attivita_4select"
                    label="Scegli attività da aggiungere"
                    speedDialStyle="z-index: 777;position:relative !important"
                    :menu-props="{ closeOnContentClick: true }"
                    v-model="attivita_4select_model"
                    :item-text="(item) => `${item.cod} - ${item.descrizione}`"
                    item-value="id"
                    :items="this.attivita_4select"
                    append-outer-icon="mdi-plus"
                    @click:append-outer="
                    newSchedaScadenza();
                    $refs.attivita_4select.isMenuActive = false;
                  "
                    :loading="attivita_select_loading"
                    cache-items
                    return-object
                    clearable
                >
                  <template v-slot:item="data">
                    <v-icon class="mr-1" :style="`color:${data.item.color}`">{{ data.item.icon }}</v-icon>
                    {{ data.item.cod }} - {{ data.item.descrizione }}
                  </template>
                </v-autocomplete>

                <!--                replico i pulsanti solitamente inseriti nello slot del tableitems
                tale scelta per ottimizzare lo spazio a video, infatti è stato tolto il toolbar title dal tableitems e si spostano i pulsanti accanto ad altri componenti-->
                <v-row>


                </v-row>

                <TableItems class="my-0 py-0"
                            ref="table_scadenze"
                            resource-collection-name="ScadenzaResourceListCollection"
                            model-name-prop="Scadenza"
                            :sort_by="['Data']"
                            new-view-name="SchedaScadenza"
                            :showTopToolbar="false"
                            :show-title="false"
                            :show-refresh-btn="false"
                            :show-new-btn="false"
                            @new-item-click="
                    saveItem().then(() => {
                      $router.push({
                        name: 'NewSchedaScadenza',
                        query: { pratica_id: form.id.val },
                      });
                    })
                  "
                            :customNewItem="() => {}"
                            :enable-pagination="false"
                            :hide-footer="true"
                            :base-query-filter="[
                    {
                      name: 'pratiche_id',
                      type: 'AND',
                      val: [pratica_id],
                      glue: 'and',
                    },
                  ]"
                >
                  <template slot="mj_top_toolbar_prepend" slot-scope="data">
                    <v-tooltip bottom v-if='data.selected.length > 0'>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn

                            v-bind="attrs"
                            v-on="on"
                            fab
                            x-small
                            color="red white--text"
                            class="ml-2"
                            @click="syncGCal"
                        >
                          <v-icon>mdi-calendar-arrow-right</v-icon>
                        </v-btn>
                      </template>
                      <span>Invia a G.Cal</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if='data.selected.length > 0'>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            fab
                            x-small
                            color="green white--text"
                            class="ml-2"
                            @click="concludiScadenze"
                        >
                          <v-icon>mdi-check-all</v-icon>
                        </v-btn>
                      </template>
                      <span>Segna come Conclusa</span>
                    </v-tooltip>
                  </template>

                </TableItems>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>


        <v-row>

        </v-row>

        <!-- ANAGRAFICHE -->
        <v-row class="mt-2">
          <v-col cols="6">
            <v-card class="scroll-y" max-height="370">
              <v-card-title class="teal lighten-1 white--text py-1 sticky-zero"
              >

                Anagrafiche

                <v-spacer/>
                <v-icon class="white--text mr-1">mdi-link
                </v-icon>

              </v-card-title>
              <v-card-text>
                <v-row class="mt-6">
                  <v-col>
                    <v-autocomplete
                        dense
                        label="Associa Anagrafica"
                        chips
                        small-chips
                        multiple
                        clearable
                        :item-text="(item) => `${(item.cognome) ? item.cognome : '' } ${(item.nome) ? item.nome : ''}`"
                        item-value="id"
                        :items="this.selects.anagrafiche"
                        cache-items
                        return-object
                        v-model="selected_anagrafiche"

                    >
                      <template slot="prepend-item">
                        <v-list-item link @click.stop.prevent="newSchedaAnagrafica();">
                          <v-icon>mdi-plus</v-icon>
                          Crea Nuova Anagrafica
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-list
                        v-if="form.pratica_has_anagrafiche.val == null ||form.pratica_has_anagrafiche.val.length == 0"
                        outlined rounded dense>
                      <v-list-item

                      >
                        <v-list-item-avatar>
                          <v-icon>mdi-information-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                          >Nessuna Anagrafica associata alla Pratica
                          </v-list-item-title
                          >
                          <v-list-item-subtitle class="overline"
                          >per collegare scegli e clicca
                          </v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-simple-table dense v-else>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-left">
                            Dati
                          </th>
                          <th class="text-left">
                            Telefono
                          </th>
                          <th class="text-left">
                            Email
                          </th>
                          <th>Nota</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(pratica_has_anagrafiche,index) in form.pratica_has_anagrafiche.val"
                            :key="pratica_has_anagrafiche.anagrafica.id"
                        >
                          <td class="text-left">{{
                              `${pratica_has_anagrafiche.anagrafica.nome ? pratica_has_anagrafiche.anagrafica.nome : ''} ${pratica_has_anagrafiche.anagrafica.cognome ? pratica_has_anagrafiche.anagrafica.cognome : ''}`
                            }}
                          </td>
                          <td class="text-left">{{ pratica_has_anagrafiche.anagrafica.telefono }}</td>
                          <td class="text-left">{{ pratica_has_anagrafiche.anagrafica.email }}</td>
                          <td>
                            <v-text-field hide-details append-icon="mdi-pencil"
                                          v-model="form.pratica_has_anagrafiche.val[index].nota"></v-text-field>
                          </td>
                          <td>
                            <v-btn icon @click="removeAnagraficaFromPratica(pratica_has_anagrafiche.anagrafica)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- LINKS -->
          <v-col cols="6">
            <v-card class="scroll-y" max-height="370">
              <v-card-title class="teal lighten-1 white--text py-1 sticky-zero"
              >

                Link Documenti

                <v-file-input color="primary" class="ml-3 my-0 py-0 " hide-input
                              prepend-icon="mdi-folder-open-outline"></v-file-input>

                <v-spacer/>
                <v-icon class="white--text mr-1"
                >mdi-link
                </v-icon>

              </v-card-title
              >
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field
                        label="Digita un link da aggiungere"
                        v-model="currentLink"
                        append-outer-icon="mdi-plus"
                        @click:append-outer="
                        appendLink();
                        currentLink = '';
                      "
                        clearable
                    >
                    </v-text-field>
                    <v-list outlined rounded dense>
                      <v-list-item
                          v-show="
                          form.pratica_links.val == null ||
                          form.pratica_links.val.length == 0
                        "
                      >
                        <v-list-item-avatar>
                          <v-icon>mdi-information-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                          >Nessun Link per la pratica
                          </v-list-item-title
                          >
                          <v-list-item-subtitle class="overline"
                          >per collegare scegli e premi sul
                            +
                          </v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <template
                          two-line
                          v-for="(link, index) in form.pratica_links.val"
                      >
                        <v-list-item :key="index">
                          <v-list-item-avatar @click="openLink(link)">
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title @click="openLink(link)">{{
                                link.url
                              }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field
                                  dense
                                  :rules="[rules.required]"
                                  placeholder="descrizione link"
                                  v-model="link.descrizione"
                              ></v-text-field>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-spacer></v-spacer>
                          <v-list-item-action>
                            <v-btn icon @click="removeLink(link)">
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn
                            >
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider
                            v-if="index !== form.pratica_links.val.length - 1"
                            :key="'divider_' + index"
                        ></v-divider>
                      </template>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!--ARCHIVIA FILES-->
        <v-row v-if="has_sftp_support">
          <v-col cols="12">
            <v-card class="mt-5 scroll-y" max-height="370">
              <v-card-title class="teal lighten-1 white--text py-1 sticky-zero">Archivia File/Email
                <v-spacer/>
                <v-icon class="white--text mr-1"
                >mdi-paperclip
                </v-icon
                >
              </v-card-title
              >
              <v-card-text>
                <MjUploader
                    ref="mj_uploader"
                    belong_col_name="pratiche_id"
                    belong_api_url="/api/allegati_pratica"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>


        <SchedaToolbar
            :error_show="error_show"
            :error_text="error_text"
            :edit_not_saved="edit_not_saved"
            :edit_mode="editMode"
            :new_button_visibile="true"
            v-on:newItemClick="newItem()"
            v-on:saveItemClick="saveItem()"
            v-on:goBackClick="goBack()"
            :speedDialVisible="true"
            :speed-dial-title="this.form.cod.val ? this.form.cod.val : 'COD' "
        />
      </v-container>
    </v-form>

  </v-container>
</template>

<script>
import schedaMixin from "@/mixins/SchedaMixin.js";
import ValidationRulesMixin from "@/mixins/ValidationRulesMixin.js";
import SchedaToolbar from "@/components/SchedaToolbar.vue";
import TableItems from "@/views/TableItems.vue";
import MjDateOrTimePicker from "@/components/MjDateOrTimePicker.vue";
import MjUploader from "@/components/MjUploader.vue";


import mj_axios from "@/mj_axios.js";


export default {
  name: "SchedaPratica",
  mixins: [schedaMixin, ValidationRulesMixin],
  components: {SchedaToolbar, MjDateOrTimePicker, MjUploader, TableItems},
  computed: {
    has_sftp_support() {
      return this.$store.state.studio.has_sftp;
    },
    selected_anagrafiche: {
      get() {

        if (this.form.pratica_has_anagrafiche && this.form.pratica_has_anagrafiche.val) {
          return this.form.pratica_has_anagrafiche.val.map(pratica_has_anagrafiche => pratica_has_anagrafiche.anagrafica)
        } else {
          return [];
        }
      },
      set(anagrafiche) {


        //CICLA LE ANAGRAFICHE SCELTE E VERIFICA SE NELLA STRUTTURA GIA' ESISTENTE this.form.pratica_has_anagrafiche
        //C'è GIA' UNA ANAGRAFICA IN TAL CASO CATTURO LA NOTA  IN MODO DI NON PERDERLA.
        this.form.pratica_has_anagrafiche.val = anagrafiche.map((anagrafica) => {
          if (this.form.pratica_has_anagrafiche.val) {
            const existing_pratica_has_anagrafiche = this.form.pratica_has_anagrafiche.val.find((pha) => pha.anagrafica.id === anagrafica.id);
            if (existing_pratica_has_anagrafiche && existing_pratica_has_anagrafiche.nota) {
              return existing_pratica_has_anagrafiche;
            }
          }
          return {'anagrafica': anagrafica};
        });
      }
      ,
    },
    pratica_id() {
      return this.form.id.val;
    },
  },
  data: () => ({
    currentLink: "",

    attivita_4select: [],
    attivita_4select_model: null,
    attivita_select_loading: false,
    form: {
      id: {type: "integer", val: "", default_val: ""},
      cod: {type: "string", val: "", default_val: ""},
      nome: {type: "string", val: "", default_val: ""},
      nota: {type: "text", val: "", default_val: ""},
      stato: {type: "integer", val: "", default_val: "0"},
      data: {type: "datetime", val: "", default_val: ""},
      pratica_links: {type: "array", val: "", default_val: ""},
      users_id: {
        type: "integer",
        val: "",
        default_val: "",
        loadSelect: true,
        apiUrl: "/api/responsabili_pratiche",
      },
      link_video_chat: {type: "string", val: "", default_val: ""},
      pratica_has_anagrafiche: {
        type: "array",
        val: [],
      },
      //usato per caricare l'autocomplete con le varie possibilità, ignorata su b.e.
      anagrafiche: {
        type: "array",
        val: [],
        loadSelect: true,
        apiUrl: "/api/list/Anagrafica/AnagraficaCompleteResourceListCollection",
      },
    },
    apiUrl: "/api/pratiche",
  }),
  mounted: function () {
    this.loadAttivitaSelect();
  },
  methods: {
    loadAttivitaSelect: function () {
      this.attivita_select_loading = true;
      // const filter_array = [{ name: "AttivitaCollegate", type: "has_not" }];
      // const filter_part = `filters=${JSON.stringify(filter_array)}`;

      mj_axios
          .get(`/api/list/Attivita/AttivitaResource4SelectCollection`)
          .then((response) => {
            this.attivita_4select = response.data.data;
            // this.loading_overlay = false;
            this.attivita_select_loading = false;
          })
          .catch(() => {
            this.error_show = true;
            this.error_text = "Errore nel caricamento dati";
            // this.loading_overlay = false;
            this.attivita_select_loading = false;
          });
    },
    //ovverride + metodi aggiuntivi
    saveItem: function () {
      //ovverride + metodi aggiuntivi

      //faccio in modo che in caso di zero anagrafiche scelte venga mandato un array vuoto (necessario per il controller)
      if (this.form.pratica_has_anagrafiche.val == null) {
        this.form.pratica_has_anagrafiche.val = [];
      }
      const ret = schedaMixin.methods.saveItem.call(this);


      return ret;
    },
    // resetForm: function () {
    //   //ovverride + metodi aggiuntivi

    //   this.$refs.table_scadenze.upda
    //   return schedaMixin.methods.resetForm.call(this);
    // },
    openLinkVideoChat: function () {
      if (
          this.form.link_video_chat.val &&
          this.form.link_video_chat.val.length > 0
      ) {
        window.open(
            this.form.link_video_chat.val,
            "Video Chat",
            "location=0,titlebar=1"
        );
      } else {
        this.error_text = "Campo Link Video è vuoto!";
        this.error_show = true;
      }
    },
    openAnagrafica: function (item) {
      let routeData = this.$router.resolve({
        name: "SchedaAnagrafica",
        params: {id: item.id},
      });
      window.open(routeData.href, item.cognome_nome, "location=0,titlebar=1");
    },

    openLink: function (link) {
      window.open(link.url, link.descrizione, "location=0,titlebar=1");
    },
    appendLink() {

      if (!this.form.pratica_links.val) {
        this.form.pratica_links.val = [];
      }


      this.form.pratica_links.val.push({url: this.currentLink});
    },
    removeLink(link) {
      const index = this.form.pratica_links.val.indexOf(link);
      if (index >= 0) this.form.pratica_links.val.splice(index, 1);
    },
    newSchedaAnagrafica() {
      this.saveItem().then(() => {
        this.$router.push({
          name: "NewSchedaAnagrafica",
          query: {pratica_id: this.form.id.val}
        });
      });
    },
    newSchedaScadenza() {
      if (this.attivita_4select_model) {
        this.saveItem().then(() => {
          this.$router.push({
            name: "NewSchedaScadenza",
            query: {
              copy_attivita_id: this.attivita_4select_model.id,
              pratica_id: this.$route.params.id,
            },
          });
        });
      } else {
        this.error_show = true;
        this.error_text = "Scegli un Attività di riferimento";
      }
    },
    /*function replicata anche su tableitemsscadenze, se aggiorni cambia anche li o centralizza la function*/
    concludiScadenze: function () {
      if (
          this.$refs.table_scadenze.selected == null ||
          this.$refs.table_scadenze.selected.length == 0
      ) {
        this.snack_bar_show = true;
        this.error_text = `Non hai scelto alcuna riga..`;
      } else {
        this.loading_overlay = true;
        this.error_show = false;

        let params = {ids: this.$refs.table_scadenze.selected_ids};
        const axios_promise = mj_axios.post("/api/concludi_scadenze", params); //insert

        axios_promise
            .then(() => {
              this.$refs.table_scadenze.loadItems(false);
            })

            .catch((e) => {
              // const status = e.response ? e.response.status : null;
              let message =
                  e.response && e.response.data ? e.response.data.message : null;

              this.error_show = true;
              this.error_text = `Errore nel Salvataggio dati  ${
                  message ? message : ""
              }`;
            })
            .then(() => {
              this.loading_overlay = false;
            });
      }
    },
    removeScadenze(){
      if (
          this.$refs.table_scadenze.selected == null ||
          this.$refs.table_scadenze.selected.length == 0
      ) {
        this.snack_bar_show = true;
        this.error_text = `Non hai scelto alcuna riga..`;
      } else {
        this.loading_overlay = true;
        this.error_show = false;


        const axios_promise = mj_axios.delete(
            `/api/scadenze/${JSON.stringify(this.$refs.table_scadenze.selected_ids)}?force_delete=auto`
        );

        axios_promise
            .then(() => {
              this.$refs.table_scadenze.loadItems(false);
            })

            .catch((e) => {
              // const status = e.response ? e.response.status : null;
              let message =
                  e.response && e.response.data ? e.response.data.message : null;

              this.error_show = true;
              this.error_text = `Errore nella cancellazione  ${
                  message ? message : ""
              }`;
            })
            .then(() => {
              this.loading_overlay = false;
            });
      }
    },
    removeAnagraficaFromPratica(anagrafica) {
      this.form.pratica_has_anagrafiche.val = this.form.pratica_has_anagrafiche.val.filter(a => a.anagrafica.id !== anagrafica.id);
    },

    /*funzione presente anche su tableitemsscadenza centralizza o se modifichi cambia anche lì*/
    syncGCal: function () {
      this.loading_overlay = true;
      this.error_show = false;

      let params = {ids: this.$refs.table_scadenze.selected_ids};
      const axios_promise = mj_axios.post("/api/sync_gcal_scadenze", params);

      axios_promise
          .then(() => {
            this.$refs.table_scadenze.loadItems(false);
          })

          .catch((e) => {
            // const status = e.response ? e.response.status : null;
            let message =
                e.response && e.response.data ? e.response.data.message : null;

            this.error_show = true;
            this.error_text = `Errore nella Sincronizzazione dati  ${
                message ? message : ""
            }`;
          })
          .then(() => {
            this.loading_overlay = false;
          });


    }
  },
  // watch:{
  //  pratica_id() {
  //       
  //       this.$refs.table_scadenze.loadItems();
  //   },
  // }
};
</script>
